

















































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Types
import { IAccount } from "@/models/accounts";
import { IAffiliate } from "@/models/affiliate";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";

@Component({
  computed: {
    ...mapGetters({
      brandName: "brand/name"
    })
  },
  components: {
    "affiliate-links-table": () =>
      import("@/components/app/global/affiliate/affiliateLinksTable.vue"),
    "affiliate-referrals-table": () =>
      import("@/components/app/global/affiliate/affiliateReferralsTable.vue")
  }
})
export default class AdminClientAffiliateOverviewView extends Vue {
  // Inject

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  // mapGetters

  public brandName!: string;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: true })
  public affiliate!: IAffiliate;

  // Computed

  public get affiliateData() {
    return this.$affiliateData();
  }
}
